import React from "react";
import {
  AssetCell,
  AssetLogo,
  AssetSymbol,
  AssetName,
  IndustryCell,
  PriceCell,
  WeightCell,
} from "./TopHoldings.styles";

const formatCurrency = (value) => {
  if (isNaN(value)) return "$0.00";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(value);
};

const formatPercent = (value) => {
  if (isNaN(value)) return "0.00%";
  return `${(value * 100).toFixed(2)}%`;
};

export const columns = [
  {
    dataField: "asset",
    text: "Asset",
    props: {
      cell: ({ row }) => {
        return (
          <AssetCell>
            <AssetLogo
              src={row.original.asset.imageUrl}
              alt={row.original.asset.symbol}
            />
            <div>
              <AssetSymbol>{row.original.asset.symbol}</AssetSymbol>
              <AssetName>{row.original.asset.name}</AssetName>
            </div>
          </AssetCell>
        );
      },
    },
  },
  {
    dataField: "weight",
    text: "Weight",
    props: {
      cell: ({ getValue }) => (
        <WeightCell>{formatPercent(getValue())}</WeightCell>
      ),
    },
  },
  {
    dataField: "sharePrice",
    text: "Share Price",
    props: {
      cell: ({ getValue }) => (
        <PriceCell>{formatCurrency(getValue())}</PriceCell>
      ),
    },
  },
  {
    dataField: "industry",
    text: "Industry",
    props: {
      cell: ({ getValue }) => <IndustryCell>{getValue()}</IndustryCell>,
    },
  },
];
